import { TextField } from '@mui/material';
import { styled } from '@mui/system';

export const RoundedTextInput = styled(TextField)(() => ({
  '& fieldset': {
    borderRadius: '25px',
  },
}));